import { PaperClipIcon } from '@heroicons/react/20/solid'

const SupportDocs = () => {
    const documents = [
        {
            name: "HRMS Manual for employees",
            url: "/pdf/HRMS Manual for employees.pdf"
        },
        {
            name: "HRMS Manual for Employers",
            url: "/pdf/HRMS Manual for Employers.pdf"
        },
        {
            name: "An Employers Guide RTW Checks",
            url: "https://assets.publishing.service.gov.uk/media/68b6b7e7536d629f9c82a9a1/RTW+Checklist__final_.pdf"
        },
        {
            name: "Appendix D - Advertising Policy",
            url: "https://drive.google.com/file/d/170HqUMa2DHfXBjAMqp-TT6AU7VuYyjvZ/view?usp=sharing"
        },
        {
            name: "Appendix D Sponsor Guidance - Records Keeping",
            url: "https://assets.publishing.service.gov.uk/media/64c3b960331a65000d934de9/Sponsor-guidance-Appendix-D-04-22.pdf"
        },
        {
            name: "Candidate Assessment Matrix",
            url: "https://docs.google.com/spreadsheets/d/1f8z0e3Xf0l9Vbs4QgPc5SqaQeF4kOqVz/edit?usp=sharing&ouid=108357598224966248146&rtpof=true&sd=true"
        },
        {
            name: "Employer's right to work checklist",
            url: "https://drive.google.com/file/d/17e6u_FBPuviAcbbROYdr_ytWy8_GMxBh/view?usp=sharing"
        },
        {
            name: "Reporting duties - Our Policy and Procedure",
            url: "https://drive.google.com/file/d/138mf-Mc3rVEV4yv0vkAvthPdf64JFPmu/view?usp=sharing"
        },
        {
            name: "Sponsorship duties - Our Policy and Procedure",
            url: "https://drive.google.com/file/d/1xsgYn9ISATTvAMA51i_Nc-3Dwno3f-tw/view?usp=sharing"
        },
        {
            name: "Vacancy and recruitment sponsor checklist",
            url: "https://drive.google.com/file/d/1MRYSHc0jRUqC8SGt08hUN2lIoFJzt3VQ/view?usp=sharing"
        },
    ];
    return (
        <div className="pt-4 border-t">
            <p className="text-2xl font-bold">
                Knowledge Base
            </p>
            <ul role="list" className="divide-y divide-gray-100 rounded-md border border-gray-200 mt-4">
                {documents.map((doc, i) => (
                    <li
                        key={i}
                        className="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                        <div className="flex w-0 flex-1 items-center">
                            <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                            <div className="ml-4 flex min-w-0 flex-1 gap-2">
                                <span className="truncate font-medium">
                                    {doc.name}
                                </span>
                            </div>
                        </div>
                        <div className="ml-4 flex-shrink-0">
                            <a href={doc.url}
                                target='_blank'
                                className="font-medium text-blue-600 hover:text-blue-500">
                                Download
                            </a>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
};
export default SupportDocs;